module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/slider/image18-cba57fedc9daf0f25f4b145527f68785.jpg";